import { TableColumnMeta } from "ds/components/Table/types";

export const TEMPLATES_WORKBENCH_COLUMNS_STORAGE_KEY = "templatesWorkbenchColumnsConfig";

export enum TEMPLATES_WORKBENCH_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  LABELS = "LABELS",
  LATEST_VERSION = "LATEST_VERSION",
  SPACE = "SPACE",
  DEPLOYMENTS = "DEPLOYMENTS",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const TEMPLATES_WORKBENCH_COLUMN_CONFIG: Record<
  TEMPLATES_WORKBENCH_COLUMN_ID,
  TableColumnMeta
> = {
  [TEMPLATES_WORKBENCH_COLUMN_ID.NAME]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATES_WORKBENCH_COLUMN_ID.DESCRIPTION]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATES_WORKBENCH_COLUMN_ID.LABELS]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATES_WORKBENCH_COLUMN_ID.LATEST_VERSION]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.LATEST_VERSION,
    title: "Latest version",
    minWidth: 160,
    defaultWidth: 160,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATES_WORKBENCH_COLUMN_ID.SPACE]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 120,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATES_WORKBENCH_COLUMN_ID.DEPLOYMENTS]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.DEPLOYMENTS,
    title: "Deployments",
    minWidth: 160,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [TEMPLATES_WORKBENCH_COLUMN_ID.DROPDOWN]: {
    id: TEMPLATES_WORKBENCH_COLUMN_ID.DROPDOWN,
    title: "Template actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const TEMPLATES_WORKBENCH_SORT_CONFIG: Record<string, string> = {
  [TEMPLATES_WORKBENCH_COLUMN_ID.NAME]: "name",
  [TEMPLATES_WORKBENCH_COLUMN_ID.LATEST_VERSION]: "state",
  [TEMPLATES_WORKBENCH_COLUMN_ID.SPACE]: "space",
  [TEMPLATES_WORKBENCH_COLUMN_ID.DEPLOYMENTS]: "deployments",
};
